import { createTheme } from '@mui/material/styles'

export default createTheme({
	typography: {
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
			'Work Sans',
		],
		h1: {
			fontSize: '2rem',
		},
		h2: {
			fontSize: '1.35rem',
			fontWeight: '500',
		},
		h3: {
			fontSize: '1.25rem',
		},
	},
	palette: {
		primary: {
			main: '#36a7e4',
		},
		secondary: {
			main: '#374151',
		},
		common: {
			white: '#fff',
			dark: '#333',
		},
		error: {
			main: '#f00',
		},
	},
})

